import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authorization-gate/package-store/$packageFamilyId/packages/$packageId/')({
	beforeLoad: ({ params }) => {
		throw redirect({ to: '/package-store/$packageFamilyId/packages/$packageId/datasheet', params });
	},
});
